const styles = (theme) => ({
  toggleOn: {
    color: theme.palette.primary.dark,
    cursor: 'pointer',
    fontSize: '50px',
  },
  toggleOff: {
    color: '#888888',
    cursor: 'pointer',
    fontSize: '50px',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  toggleTextOn: {
    color: theme.palette.primary.dark,
    fontSize: '1rem',
    fontWeight: 600,
  },
  toggleTextOff: {
    color: '#888888',
    fontSize: '1rem',
    fontWeight: 600,
  },
  toggleTextWrapper: {
    textAlign: 'center',
    display: 'inline-block',
    marginTop: '-14px',
  },
});

export default styles;
